import { SUPPORT_EMAIL } from "@/lib/account-requests";

export const DEACTIVATED_MESSAGE = `This account has been deactivated. Contact ${SUPPORT_EMAIL} to restore it.`;

/** A brand account an admin has rejected. It is signed out at login and cannot use the app. */
export const isDeactivated = (status: string | null | undefined): boolean => status === "rejected";
